<article
  #cardItemContainer
  appStopPropagation
  tabindex="0"
  [attr.aria-label]="baseData?.record?.title"
  (click)="openItemDetail($event)"
  (keydown.enter)="openItemDetail($event)"
  (keydown.space)="openItemDetail($event)"
  [ngClass]="{'can-hover': canHover}">
  <section class="cover-container" [ngClass]="{'cover-container--list': viewMode === 'LIST'}">
    <opac-record-cover
      [coverUrl]="baseData?.cover"
      [icon]="baseData?.icon"
      [isList]="baseData?.isList"></opac-record-cover>

    <span
      *ngIf="viewMode === 'GRID'"
      aria-hidden="true"
      [style.pointer-events]="baseData?.fromBookClub ? 'none' : 'auto'"
      class="title-grid"
      [ellipsis]="2"
      [ngClass]="{ 'common-font': dominantColors?.showGradient }">
      {{ baseData?.title }}
    </span>

    <mat-progress-bar
      *ngIf="percentage"
      class="progress"
      mode="determinate"
      [value]="percentage"
      [opacTooltip]="percentage + '%'">
    </mat-progress-bar>
  </section>

  <section class="content-container" *ngIf="viewMode === 'LIST'">
    <div class="item__right">
      <div class="item__right__info" [class.extra-height]="baseData?.record?.publicationDate && showPublicationDate">
        <div class="record-title">
          <span
            *ngIf="baseData?.fromBookClub"
            [opacTooltip]="'user.bookclub.title' | translate"
            class="odilo-icon from-bookclub">
            bookclub
          </span>
          <span
            *ngIf="!baseData?.rssRhId"
            [style.pointer-events]="baseData?.fromBookClub ? 'none' : 'auto'"
            [appRecordTitle]="baseData?.record"
            class="title"
            [ellipsis]="2">
          </span>
          <span
            *ngIf="baseData?.rssRhId"
            [style.pointer-events]="baseData?.fromBookClub ? 'none' : 'auto'"
            class="title"
            [ellipsis]="2"
            [ngClass]="{ 'common-font': dominantColors?.showGradient }">
            {{ baseData?.title }}
          </span>
          <button *ngIf="issueDate" class="record-issueDate">{{ issueDate | parseDate }}</button>
        </div>

        <ng-container *ngIf="baseData?.record?.wishListInfo?.id; else author">
          <div class="subtitle">
            <span *ngIf="baseData?.record?.wishListInfo?.associatedElements" class="subtitle__list">
              {{ baseData?.record?.wishListInfo?.associatedElements?.length }} {{
              (baseData?.record?.wishListInfo?.associatedElements?.length === 1 ? "general.item" : "general.items") |
              translate }}
            </span>
            <div *ngIf="baseData?.record?.wishListInfo?.followers" class="subtitle__list">
              <span class="odilo-icon">followers</span>
              <span>
                {{ baseData?.record?.wishListInfo?.followers?.length }} {{
                (baseData?.record?.wishListInfo?.followers?.length === 1 ? "lists.follower" : "lists.followers") |
                translate}}
              </span>
            </div>
          </div>
        </ng-container>

        <ng-template #author>
          <a
            *ngIf="baseData?.author"
            class="item__right__author"
            ellipsis
            [ngClass]="{ 'common-font': dominantColors?.showGradient }"
            routerLink="/results"
            [queryParams]="searchByAuthor(baseData?.author)"
            tabindex="0"
            >{{baseData?.author}}</a
          >
        </ng-template>

        <span class="publication-date" *ngIf="baseData?.record?.publicationDate && showPublicationDate"
          >{{ 'general.publicationYear' | translate }} {{ baseData.record.publicationDate | publicationDate }}</span
        >
      </div>

      <div class="item__right__content">
        <div class="item__right__rating" *ngIf="buttonPanel?.templateRef">
          <div class="rating-wrapper">
            <ng-container [ngTemplateOutlet]="buttonPanel?.templateRef"></ng-container>
          </div>
        </div>

        <div
          *ngIf="detailsRight?.length || detailsLeft?.length"
          class="item__right__details"
          [ngClass]="{ 'common-font': dominantColors?.showGradient }">
          <div
            class="details__left"
            [ngClass]="{ 'details__left--only-left': !detailsRight?.length }"
            *ngFor="let details of detailsLeft"
            tabindex="0">
            <span class="label">{{ details?.label | translate }}</span>
            <span [ngClass]="details.class" class="status">{{ details?.data }}</span>
          </div>
          <ng-container *ngIf="detailsRight?.length">
            <div class="details__right" *ngFor="let details of detailsRight" tabindex="0">
              <span class="label">{{ details?.label | translate }}</span>
              <span>{{ details?.data }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="item__right__actions">
      <ng-container [ngTemplateOutlet]="recordButtons.templateRef"></ng-container>
    </div>
  </section>
</article>
